import IconNames from '@/components/atomic/atoms/data-display/icons/symbol/enum';
import SliceNames from '@/state/enum';
import { IconsState } from '@/state/slices/icons/typings';

const iconsState: IconsState = {
	[SliceNames.ICONS]: {
		icons: [
			IconNames.LOCATION,
			IconNames.BUILD,
			IconNames.SEARCH,
			IconNames.CONTACT_AND_HELP,
			IconNames.LOGIN,
			IconNames.CHEVRON_RIGHT,
		],
	},
};

export default iconsState;
